import workoutService from '@/services/workout.service'
import { BaseAdditionalActivity, BaseWorkout, ComplexWorkout, WorkoutTypes, WorkoutIntensities, MssPreviewSlideData, MssWorkout, MssWorkoutTypeNames, MssWorkoutType, CircuitWorkout } from '@/types/workouts'
import { VuexModule, Module, Mutation, Action } from 'vuex-class-modules'
import store from '../index'
import { unique } from '@/utils/array.utils'

@Module
class EgymWorkoutDescriptionModule extends VuexModule {

    slidesArray: MssPreviewSlideData[] = []

    workout: CircuitWorkout | null = null

    previewMode = false

    get workoutPreviewSlidesData() {
        return this.slidesArray
    }

    get workoutDescription() {
        return this.workout?.description
    }

    get tags(): string[] {
        const level = this.workout ? WorkoutIntensities.get(this.workout.difficulty) as string : ''
        const trainer = this.workout?.creatorName as string
        const duration = this.workout ? workoutService.getWorkoutDuration(this.workout) : 0
        return unique([ duration, level, trainer].flat().filter(tag => tag) as string[])
    }

    get fitnessTypeTag(): any {
        return MssWorkoutTypeNames.get(MssWorkoutType.MSS_BOUTIQUE)
    }

    get equipmentTags(): string[] {
        return this.workout ? this.workout.gearList : []
    }

    get durationFormat(): string {
        return this.workout ? [ Math.floor(this.workout?.totalTime / 60).toString(), 'min' ].join(' ') : ''
    }

    get coverImageUrl(): string | null {

        if (this.workout && this.workout.coverImage) {
            const { small } = this.workout.coverImage
            return !small ? null : small
        }

        return null
    }

    @Mutation
    parse(workout: CircuitWorkout) 
    {
        this.workout = workout
        this.slidesArray = workoutService.getEgymWorkoutPreviewSlides(workout as CircuitWorkout)
    }

    @Mutation
    updatePrviewMode(previewMode: boolean) 
    {
        this.previewMode = previewMode
    }

    @Action
    init(workout: CircuitWorkout) 
    {
        this.parse(workout)
    }

    @Action
    togglePreviewMode() 
    {
        this.updatePrviewMode(!this.previewMode)
    }
}

export const egymWorkoutDescriptionModule = new EgymWorkoutDescriptionModule({ store, name: 'egymWorkoutDescriptionModule' })